(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* keep existing drawer‑open toggle */
  const drawerDetails = document.querySelector('.nav-wrapper details');
  const drawerSummary = document.querySelector('.nav-wrapper summary');
  if (drawerDetails && drawerSummary) {
    drawerSummary.addEventListener('click', () => {
      drawerDetails.classList.toggle('menu-drawer-open');
      document.body.classList.toggle('menu-drawer-open');
    });
  }

  /* — accordion logic for group divisions — */
  document.querySelectorAll('.menu-toggle').forEach((btn) => {
    const li = btn.closest('li');
    const submenu = li.querySelector('.submenu');

    const open = () => {
      submenu.hidden = false;
      submenu.style.maxHeight = submenu.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      submenu.style.maxHeight = 0;
      btn.setAttribute('aria-expanded', 'false');
      submenu.addEventListener(
        'transitionend',
        () => {
          submenu.hidden = true;
        },
        { once: true }
      );
    };

    btn.addEventListener('click', () => {
      btn.getAttribute('aria-expanded') === 'true' ? close() : open();
    });

    // Auto-open if this group contains the current page
    if (submenu && submenu.querySelector('[aria-current="page"]')) open();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-read-more]').forEach(function(wrapper) {
    var toggle = wrapper.querySelector('[data-read-more-toggle]');
    var buttonText = toggle ? toggle.querySelector('span') : null;

    if (!toggle || !buttonText) return;

    toggle.addEventListener('click', function (event) {
      event.preventDefault();

      wrapper.classList.toggle('is-expanded');
      var expanded = wrapper.classList.contains('is-expanded');

      buttonText.textContent = expanded ? 'Weniger lesen' : 'Mehr lesen';
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
